module.exports = __webpack_public_path__ + "img/CRC1_CD8T.6703f665.png";